import _ from 'lodash';
import appConfig from 'app-config';

const { MLUserTypes } = appConfig;

function MLOfferingService() {
    let userType = '';
    let allOfferings = null;

    const isUserTypeIAOrPCS = () => {
        return userType === MLUserTypes.IA || userType === MLUserTypes.PCS;
    };

    const notUserTypeIAOrPCS = () => {
        return !isUserTypeIAOrPCS();
    };

    const refreshOfferings = () => {
        /**
         * Since we don't have a submission / policy period at this point,
         * we need to manually show the offerings. I spoke to Mike Higgins,
         * and both he and the business are OK with having static values here.
         *
         * The object currentAvailableOfferings is a duplicate version of the offering pattern specified in product model.
         * This needs to be maintained if product model changes.
         *
         * code: code for the offering
         * name: name of the offering
         * priority: sequence of the offering (values taken from sequence column in product designer)
         * available: boolean
         */
        allOfferings = {
            hopdwelling: [
                {
                    code: 'HOPBasicHome_ML', name: 'Value (Basic)', priority: 1, available: false
                },
                {
                    code: 'HOPGoodHome_ML', name: 'Value Plus (Good)', priority: 2, available: true
                },
                {
                    code: 'HOPBetterHome_ML', name: 'Enhanced (Better)', priority: 3, available: false
                },
                {
                    code: 'HOPBestHome_ML', name: 'Enhanced Plus (Best)', priority: 4, available: true
                },
                {
                    code: 'HOPGrandProtectHome_ML', name: 'GrandProtect', priority: 13, available: true
                }
            ],
            hopcondo: [
                {
                    code: 'HOPBasicCondo_ML', name: 'Value (Basic)', priority: 9, available: false
                },
                {
                    code: 'HOPGoodCondo_ML', name: 'Value Plus (Good)', priority: 10, available: true
                },
                {
                    code: 'HOPBetterCondo_ML', name: 'Enhanced (Better)', priority: 11, available: false
                },
                {
                    code: 'HOPBestCondo_ML', name: 'Enhanced Plus (Best)', priority: 12, available: true
                },
                {
                    code: 'HOPGrandProtectCondo_ML', name: 'GrandProtect', priority: 14, available: true
                }
            ],
            hoprental: [
                {
                    code: 'HOPBasicRenter_ML', name: 'Value (Basic)', priority: 5, available: false
                },
                {
                    code: 'HOPGoodRenter_ML', name: 'Value Plus (Good)', priority: 6, available: true
                },
                {
                    code: 'HOPBetterRenter_ML', name: 'Enhanced (Better)', priority: 7, available: false
                },
                {
                    code: 'HOPBestRenter_ML', name: 'Enhanced Plus (Best)', priority: 8, available: true
                },
                {
                    code: 'HOPGrandProtectRenters_ML', name: 'GrandProtect', priority: 15, available: true
                }
            ],
            hop_landlord_home_ml: [
                {
                    code: 'HOPBetterLandlordHome_ML', name: 'Value Plus (Better)', priority: 17, available: true
                }
            ],
            hop_landlord_condo_ml: [
                {
                    code: 'HOPBetterLandlordCondo_ML', name: 'Value Plus (Better)', priority: 20, available: true
                }
            ],
            PersonalAuto: [
                {
                    code: 'PAValueNonIAPCS_ML', name: 'Value', priority: 4, available: false
                },
                {
                    code: 'PAValuePlusNonIAPCS_ML', name: 'Value Plus', priority: 5, available: true
                },
                {
                    code: 'PAEnhancedNonIAPCS_ML', name: 'Enhanced', priority: 7, available: false
                },
                {
                    code: 'PAEnhancedPlusNonIAPCS_ML', name: 'Enhanced Plus', priority: 8, available: true
                },
                {
                    code: 'PAGrandProtectNonIAPCS_ML', name: 'Grand Protect', priority: 10, available: true
                }
            ],
            PersonalAuto_ModernProduct: [
                {
                    code: 'Recommended', name: 'Recommended', priority: 13, available: true
                }
            ],
            HOP_ModernProduct: [
                { code: 'GoodHome_Ext', name: 'Good', priority: 22, available: true},
                { code: 'BetterHome_Ext', name: 'Better', priority: 23, available: true},
                { code: 'BestHome_Ext', name: 'Best', priority: 24, available: true},
            ],
            HOPCondo_ModernProduct: [
                { code: 'GoodCondo_Ext', name: 'Good', priority: 1, available: true },
                { code: 'BetterCondo_Ext', name: 'Better', priority: 2, available: true },
                { code: 'BestCondo_Ext', name: 'Best', priority: 3, available: true }
            ],
            HOPRenters_ModernProduct: [
                { code: 'GoodRenters_Ext', name: 'Good', priority: 1, available: true},
                { code: 'BetterRenters_Ext', name: 'Better', priority: 2, available: true},
                { code: 'BestRenters_Ext', name: 'Best', priority: 3, available: true}
            ],
            LLH_ModernProduct: [
                { code: 'HOPDF1LandLordHome_Ext', name: 'Dwelling Fire One (Named Peril)', priority: 2, available: true },
                { code: 'HOPDF3LandLordHome_Ext', name: 'Dwelling Fire Three (Comprehensive)', priority: 3, available: true },
                { code: 'HOPDF3PlatinumLandLordHome_Ext', name: 'Dwelling Fire Three - Platinum Package', priority: 4, available: true }
            ],
            LLC_ModernProduct: [
                { code: 'HOPLandLordCondo_Ext', name: 'Landlord Condo (Comprehensive)', priority: 2, available: true },
                { code: 'HOPPlatinumLandLordCondo_Ext', name: 'Landlord Condo - Platinum Package', priority: 3, available: true }
            ]
        };
    };

    const getFirstAvailableOfferingForProduct = (productCode) => {
        if (allOfferings === null) {
            refreshOfferings();
        }
        return allOfferings[productCode][0];
    };

    const refreshOfferingsWithUserType = (anUserType) => {
        if (userType !== anUserType) {
            userType = anUserType;
            refreshOfferings();
        }
    };
    const getAvailableOfferingsForProduct = (productCode) => {
        if (_.isUndefined(productCode)) {
            return [];
        }

        if (allOfferings === null) {
            refreshOfferings();
        }

        if (_.isUndefined(allOfferings[productCode])) {
            return [];
        }

        return allOfferings[productCode].filter((of) => of.available);
    };

    return {
        refreshOfferingsWithUserType: refreshOfferingsWithUserType,
        getAvailableOfferingsForProduct: getAvailableOfferingsForProduct,
        getFirstAvailableOfferingForProduct: getFirstAvailableOfferingForProduct
    };
}

export default MLOfferingService;